module.exports = __webpack_public_path__ + "070a8787e6a57b5e3d0a04691ae21be3.pdf";